// Плавающая кнопка справа-снизу. Открывает SupportModal.
// Видна на всех экранах кабинета, кроме fullscreen-страницы игры
// (там CabinetLayout сам ничего лишнего не рендерит).
import React, { useState } from "react";
import { ChatBubbleLeftRightIcon } from "../icons/ChatBubbleLeftRightIcon";
import SupportModal from "./SupportModal";
import "../../styles/support.css";

export default function SupportFab() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        className="sup-fab"
        onClick={() => setOpen(true)}
        aria-label="Связаться с разрабом"
        title="Связаться с разрабом"
      >
        <ChatBubbleLeftRightIcon size={28} color="#fff" />
      </button>
      {open && <SupportModal onClose={() => setOpen(false)} />}
    </>
  );
}
